<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/Agents'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-user-tie"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="aglKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก รหัสตัวแทนจำหน่าย ชื่อตัวแทนจำหน่าย อีเมล ที่อยู่ ชื่อผู้ติดต่อ เบอร์โทรผู้ติดต่อ"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'agentList_activeStatusKey'"
                    :name="'agentList_activeStatusKey'"
                    :select2-options="agentList_activeStatusKeyOptions"
                    v-model="agentList_activeStatusKey"
                    ref="agentList_activeStatusKeySelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <label>เขตการขาย :</label>
                <select
                  id="agentList_areaKey"
                  name="agentList_areaKey"
                  class="form-control m-select2"
                  style="width: 100%;"
                  multiple="multiple"
                ></select>
              </div> -->
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <label>เขตการขาย(เบียร์สด) :</label>
                <!-- <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'alAreaNew'"
                  :name="'alAreaNew'"
                  :select2-options="alAreaNewOptions"
                  v-model="alAreaNew"
                  ref="alAreaNewSelect2"
                  multiple
                ></select2> -->
                <treeselect
                  v-model="alAreaNew"
                  :multiple="true"
                  :options="alAreaNewOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก"
                />
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>จังหวัด :</label>
                  <treeselect
                    v-model="agentListProvinceKey"
                    :multiple="true"
                    :options="agentListProvinceKeyOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย :</label>
                  <!-- <select
                    id="agentList_agentKey"
                    name="agentList_agentKey"
                    class="form-control m-select2"
                    style="width: 100%;"
                    multiple="multiple"
                  ></select> -->
                  <treeselect
                    v-model="agentListAgentKey"
                    :multiple="true"
                    :clear-on-select="true"
                    :options="agentListAgentKeyOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-4">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-8 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportAgent"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="agentTable"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th class="all">รหัสตัวแทนจำหน่าย</th>
                    <th class="all">ชื่อตัวแทนจำหน่าย</th>
                    <th class="none">ที่อยู่</th>
                    <th class="all">จังหวัด</th>
                    <th class="all">เขตการขาย(เบียร์สด)</th>
                    <th class="none">เบอร์โทร</th>
                    <th class="none">Email</th>
                    <th class="none">ชื่อผู้ติดต่อ</th>
                    <th class="none">เบอร์โทรผู้ติดต่อ</th>
                    <th class="none">Lat</th>
                    <th class="none">Lng</th>
                    <!-- <th class="none">รูปภาพ</th> -->
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import { VLazyImagePlugin } from "v-lazy-image";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

Vue.use(VLazyImagePlugin);
require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#agentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Agents/" + this.data.agentCodeSap + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                Swal.fire("สำเร็จ", response.data.message, "success");
                self.$parent.reloadDataTable();
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#agentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Agents/" + this.data.agentCodeSap + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                Swal.fire("สำเร็จ", response.data.message, "success");
                self.$parent.reloadDataTable();
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let AgentActions = Vue.extend({
  // <a href="#" @click.prevent="deleteAgent" v-if="data.showDeleteButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ลบข้อมูลการถือครอง">
  //     <i class="la la-trash"></i>
  //   </a>
  template: `
  <div>
    <a href="#" @click.prevent="editAgent" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูลตัวแทนจำหน่าย">
      <i class="la la-edit"></i>
    </a>

  </div>`,
  methods: {
    editAgent: function() {
      router.push({ path: `/Master/Agents/Edit/${this.data.agentCodeSap}` });
    },
    deleteAgent: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบการถือครอง",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลตัวแทนจำหน่าย <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ตัวแทนจำหน่ายนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลตัวแทนจำหน่ายออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .post("/Api/Agents/" + this.data.agentCodeSap + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      agentList_areaKey: null,
      agentListProvinceKey: [],
      agentListProvinceKeyOptions: [],
      agentListAgentKey: [],
      agentListAgentKeyOptions: [],
      agentList_activeStatusKey: false,
      aglKeyword: null,
      alAreaNew: [],
      //config
      agentList_activeStatusKeyOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      alAreaNewOptions: [],
    };
  },
  methods: {
    formReset: function(e) {
      this.alAreaNew = [];
      this.agentListProvinceKey = [];
      this.agentListAgentKey = [];
      $("#agentList_areaKey")
        .val("")
        .trigger("change");

      $("#alAreaNew")
        .val("")
        .trigger("change");

      //default Active Data
      this.agentList_activeStatusKey = false;
      $("#agentList_activeStatusKey")
        .val(this.agentList_activeStatusKey + "")
        .trigger("change");
      this.aglKeyword = "";
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#agentTable").DataTable();
      table.search();
      table.draw();
    },
    exportAgent: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/exportAgent",
        responseType: "arraybuffer",
        data: {
          Department: [], //$("select#agentList_areaKey").val(),
                ProvinceId: self.agentListProvinceKey,
                AgentCodeSap: self.agentListAgentKey,
                ActiveStatus: self.agentList_activeStatusKey,
                SalesArea: self.alAreaNew,
                SearchKeyword: self.aglKeyword,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // link.download = "ข้อมูลตัวแทนจำหน่าย" + filename;
            link.download = "ข้อมูลตัวแทนจำหน่าย" //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    reloadDataTable: function(resetPaging = false) {
      $("#agentTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    LoadagentListProvinceKeyOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchProvince", {
          page: 1,
          department: [],
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.agentListProvinceKeyOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    LoadagentListAgentKeyOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          province_id: self.agentListProvinceKey,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.agentListAgentKeyOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadalAreaNewOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.alAreaNewOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    //default Active Data
    self.agentList_activeStatusKey = false;
    $("#agentList_activeStatusKey")
      .val(self.agentList_activeStatusKey + "")
      .trigger("change");

    self.LoadagentListProvinceKeyOptions();
    self.LoadagentListAgentKeyOptions();
    self.LoadalAreaNewOptions();

    $("#agentList_areaKey").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Agents/Select2SearchDepartment",
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
          };
          return query;
        },
        processResults: function(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more,
            },
          };
        },
        transport: function(params, success, failure) {
          params.beforeSend = function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        },
      },
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#agentTable");
    table
      .DataTable({
        // data: dataSet,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Agents/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                Department: [], //$("select#agentList_areaKey").val(),
                ProvinceId: self.agentListProvinceKey,
                AgentCodeSap: self.agentListAgentKey,
                ActiveStatus: self.agentList_activeStatusKey,
                SalesArea: self.alAreaNew,
                SearchKeyword: self.aglKeyword,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],
        columns: [
          {
            data: null,
            className: "details-control",
            defaultContent: "",
            orderable: false,
          },
          { data: "agentCodeSap" },
          { data: "agentName", width: "20%",
            
          render: function(data, type, full, meta) {
              var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>"+data+"</pre>";
              return html;
            }
           },
          { data: "address" },
          { data: "provinceName", orderable: false },
          { data: "salesAreaName" },
          { data: "tel" },
          { data: "email" },
          { data: "contact" },
          { data: "contactTel" },
          { data: "latitude" },
          { data: "longitude" },
          // {
          //   data: "picture",
          //   sortable: false,
          //   render: function(data, type, row) {
          //     return `<img src="https://image.bangkokbiznews.com/kt/media/image/news/2019/04/29/833758/750x422_833758_1556527455.jpg"/>`;
          //     // return `<v-lazy-image src="https://image.bangkokbiznews.com/kt/media/image/news/2019/04/29/833758/750x422_833758_1556527455.jpg"/>`;
          //     // return `<img src="<v-lazy-image src="/Api/DownloadImg/{0}"/>" style="max-width: 200px;" />`;
          //     //   .formatUnicorn(
          //     //     Setting.rootPath + data.substr(8)
          //     //   );
          //   }
          // },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "agentCodeSap",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_AGENT",
            ]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_AGENT",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_AGENT",
            ]);
            new AgentActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    // table.trigger("draw.dt"); //call ajax delete this row
  },
  //   async mounted() {
  //     let self = this;
  //     const user = await this.$root.getUser();
  //     var table = $("#roleTable");

  //     // begin first table
  //     table
  //       .DataTable({
  //         responsive: true,
  //         processing: true,
  //         serverSide: true,
  //         searchDelay: 500,

  //         ajax: {
  //           url: "/Api/Roles/Find",
  //           type: "post",
  //           beforeSend: function(request) {
  //             request.setRequestHeader(
  //               "Authorization",
  //               "Bearer " + self.$root.user.access_token
  //             );
  //           }
  //         },

  //         // DOM Layout settings
  //         dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
  //       <'row'<'col-sm-12'tr>>
  // 			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

  //         lengthMenu: [50, 100, 200, 500],

  //         pageLength: 100,

  //         language: {
  //           lengthMenu: "Display _MENU_"
  //         },

  //         // Order settings
  //         order: [[1, "desc"]],

  //         columns: [
  //           { data: "roleName", width: "20%" },
  //           { data: "description" },
  //           {
  //             data: "userCount",
  //             className: "text-center",
  //             width: "10%",
  //             render: function(data, type, full, meta) {
  //               return data;
  //             }
  //           },
  //           {
  //             data: "roleName",
  //             className: "text-center",
  //             width: "10%",
  //             orderable: false,
  //             render: function(data, type, full, meta) {
  //               return '<div class="actions"></div>';
  //             }
  //           }
  //         ]
  //       })
  //       .on("draw.dt", function() {
  //         $(".actions").each(function(i, el) {
  //           var $dt = table.DataTable();
  //           var $tr = $(el)
  //             .parents("tr")
  //             .first();
  //           var data = $dt.row($tr).data();
  //           if (data) {
  //             data.showEditButton = self.$root.canShow("MASTER_ROLE_EDIT");
  //             data.showDeleteButton = self.$root.canShow("MASTER_ROLE_DELETE");
  //             new RoleActions({ data: { data }, parent: self }).$mount(el);
  //           }
  //         });
  //       });
  //   }
};
</script>

<style lang="scss">
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Agent/AgentList.vue